module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bBNLC"))).then(() => parcelRequire('hEqeo'));